import React from 'react';
import styled from 'styled-components';
import { Link, Stack, Text } from '@solvhealth/jigsaw-v1';
import { Service } from '@solvhealth/types/interfaces/Location/ServicesObj';
import CDPSection from '../ClinicDetailPageFlexible/components/CDPSection';
import dataTestIds from '~/test/test-ids';

const PhoneLink = styled.a.withConfig({ componentId: 'sc-1txz2aq-0' })`
  display: inline-flex;
`;

export const getDisplayServices = (services: Record<string, Service[]>) => {
  let result = [];
  for (let serviceType in services) {
    if (services.hasOwnProperty(serviceType)) {
      let section = (
        <Stack key={serviceType} space={1}>
          <Text variant="subtitle">
            {serviceType.charAt(0).toUpperCase() + serviceType.toLowerCase().slice(1)}
          </Text>
          {services[serviceType]
            .sort((a, b) => (a.display_name > b.display_name ? 1 : -1))
            .map((s) => {
              return (
                <Text key={s.display_name} variant="body">
                  {s.display_name}
                </Text>
              );
            })}
        </Stack>
      );
      result.push(section);
    }
  }
  return result;
};

type Props = {
  locationPhone?: string;
  services: Record<string, Service[]>;
};

const ServicesList = ({ locationPhone, services }: Props) => {
  const displayServices = getDisplayServices(services);

  if (displayServices.length === 0) {
    return null;
  }

  return (
    <CDPSection
      heading="Services"
      noPaddingTop
      noSeparatorBottom
      subHeading={
        <Text as="span" muted>
          Additional pricing details are coming soon.
          {locationPhone && (
            <>
              {' '}
              In the meantime,{' '}
              <PhoneLink href={`tel:${locationPhone}`}>
                <Link inline sx={{ textDecoration: 'underline' }} textColor="gray-600">
                  call the clinic
                </Link>
              </PhoneLink>
              .
            </>
          )}
        </Text>
      }
    >
      <Stack data-testid={dataTestIds.cdp.allServices} space={3}>
        {displayServices}
      </Stack>
    </CDPSection>
  );
};

export default ServicesList;
